import {
  IBooleanOption,
  INumberOption,
  IOption,
  ISpecializationArea,
  TLabeledItem,
  TQuestionnaireTypeOption,
  TReportQuestionOption,
  TSpecialization,
} from "../types/types";
import {
  IAppointmentsProgram,
  ICompanyGroupsRRM,
  ICompanyGroupsRRMHeaders,
  IQuestion,
  IQuestionnaireCompanies,
  IQuestionnaireCompaniesHeaders,
  IQuestionnaireCompaniesTypes,
  IQuestionnaireData,
  TAddFeatureRequest,
  TGeneralRRM,
  TGroup,
  TPlan,
  TPlanPrice,
  TQuestionOption,
  TSmsMessage,
  TSupportMessage,
} from "../services/types/utils.types";
import { StylesConfig } from "react-select";
import { IContactUsTheme } from "./categories";

import {
  TAddTherapistRequest,
  TAddUserRequest,
  TRRMListEntry,
} from "../services/types/user.types";
import { TCompany, TCompanyOnboarding } from "../services/types/users.types";

import messagesIcon from "../images/messages_icon_blue.svg";
import calendarIcon from "../images/calendar_icon.svg";
import treatmentPlanIcon from "../images/treatment_plan_shortcut_icon.svg";
import reportsIcon from "../images/reports_icon.svg";
import { tWithKeyAttr as t } from "../i18nHelper";
import { TStage } from "../types/types";

// Onboarding steps builder - compute per current language
export const getOnboardingSteps = (): TStage[] => [
  { id: 1, name: t("ONBOARDING_STEP_NAME_1") || "פרטי חברה", stageNumber: 1 },
  { id: 2, name: t("ONBOARDING_STEP_NAME_2") || "איש קשר", stageNumber: 2 },
  { id: 3, name: t("ONBOARDING_STEP_NAME_3") || "הגדרות חברה", stageNumber: 3 },
  { id: 4, name: t("ONBOARDING_STEP_NAME_4") || "מסלול", stageNumber: 4 },
  { id: 5, name: t("ONBOARDING_STEP_NAME_5") || "פרטי תשלום", stageNumber: 5 },
  { id: 6, name: t("ONBOARDING_STEP_NAME_8") || "סיום", stageNumber: 6 },
];

export const getStepHeader = (stepNumber: number): string => {
  switch (stepNumber) {
    case 1:
      return t("ONBOARDING_STEP1_HEADER") || "בואו נתחיל עם כמה פרטים על החברה שלכם";
    case 2:
      return t("ONBOARDING_STEP2_HEADER") || "הוסיפו פרטי איש קשר ראשי";
    case 3:
      return t("ONBOARDING_STEP3_HEADER") || "בואו נגדיר מידע נוסף";
    case 4:
      return t("ONBOARDING_STEP4_HEADER") || "בחרו את התוכנית המתאימה לכם";
    case 5:
      return t("ONBOARDING_STEP5_HEADER") || "פרטי תשלום";
    case 6:
      return t("ONBOARDING_STEP8_HEADER") || "ברוכים הבאים ל-BPreven!";
    default:
      return "";
  }
};

export const TEST_BASE_URL = "https://api-test.bpreven.com/";
export const BASE_URL = "https://api.bpreven.com/";
// export const BASE_URL = "http://localhost:7241/";

export const DEFAULT_LANGUAGE = 'he';

/**
 * Paycall / webpbx softphone defaults. Must stay in sync with the backend
 * (PaycallController.DefaultSipDomain / DefaultSipPort and Admin_AgentSipCredentials_DML),
 * which applies these same values when the admin leaves the fields blank.
 */
export const DEFAULT_SIP_DOMAIN = "sip.webpbx.co.il";
export const DEFAULT_SIP_PORT = 443;

export const mobileWidth = "(max-width: 600px)";
export const actionReportId = 27;

export const searchOptions: TLabeledItem[] = [
  { value: "Desc", label: "שם" },
  { value: "Symbol", label: "סימן" },
  { value: "StartQuestion", label: "שאלה ראשונית" },
  { value: "Status", label: t("COLUMN_STATUS") },
];
export const searchFeaturesOptions: TLabeledItem[] = [
   { value: "all", label: "ALL" },
  { value: "Symbol", label: "SYMBOL" },
  { value: "[Desc]", label: "NAME_3" },
  { value: "Number", label: "NUMBER_2" }
];

export const questions: IContactUsTheme[] = [
  {
    title: "האם הפסיכולוגים שלכם מוסמכים?",
    text: "גישה רק לדברים החיוניים ביותר. שדרג לפרימיום וקבל שירותי תמיכה נפשית על ידי פסיכולוג מוסמך זמין 24/7, התייעצות בפורום עם מתמודדים כמוך, ועודגישה רק לדברים גישה רק לדברים החיוניים ביותר. שדרג לפרימיום וקבל שירותי תמיכה נפשית על ידי פסיכולוג מוסמך ",
  },
  {
    title: "האם הפסיכולוגים שלכם מוסמכים?",
    text: "שלכם שלכם שלכם שלכםשלכםשלכם שלכם שלכם שלכם",
  },
  {
    title: "האם הפסיכולוגים שלכם מוסמכים?",
    text: "שלכם שלכם שלכם שלכםשלכםשלכם שלכם שלכם שלכם",
  },
];

// export const searchLibraryOptions: TLabeledItem[] = [
//   { value: "all", label: "הכל" },
//   { value: "Exercises.Symbol", label: "סימן" },
//   { value: "Exercises.About", label: t('DESCRIPTION') },
//   { value: "Exercises.StatusId", label: t('COLUMN_STATUS') },
//   { value: "Exercises.Title", label: t('TITLE') },
// ];

export const questionnaireTypes: TQuestionnaireTypeOption[] = [
  { value: "Q", label: "QUESTIONNAIRE_TYPE_REGULAR", id: 1, Symbol: "Q", Name: "QUESTIONNAIRE_TYPE_REGULAR" },
  { value: "QR", label: "QUESTIONNAIRE_TYPE_REGISTRATION", id: 2, Symbol: "QR", Name: "QUESTIONNAIRE_TYPE_REGISTRATION" },
  {
    value: "QG",
    label: "QUESTIONNAIRE_TYPE_GUEST_ENTRY",
    id: 3,
    Symbol: "QG",
    Name: "QUESTIONNAIRE_TYPE_GUEST_ENTRY",
  },
  {
    value: "QT",
    label: "QUESTIONNAIRE_TYPE_THERAPIST",
    id: 4,
    Symbol: "QT",
    Name: "QUESTIONNAIRE_TYPE_THERAPIST",
  },
];
export const getQuestionnaireTypes = (): TQuestionnaireTypeOption[] => [
  { value: "Q", label: t("QUESTIONNAIRE_TYPE_REGULAR"), id: 1, Symbol: "Q", Name: t("QUESTIONNAIRE_TYPE_REGULAR") },
  { value: "QR", label: t("QUESTIONNAIRE_TYPE_REGISTRATION"), id: 2, Symbol: "QR", Name: t("QUESTIONNAIRE_TYPE_REGISTRATION") },
  {
    value: "QG",
    label: t("QUESTIONNAIRE_TYPE_GUEST_ENTRY"),
    id: 3,
    Symbol: "QG",
    Name: t("QUESTIONNAIRE_TYPE_GUEST_ENTRY"),
  },
  {
    value: "QT",
    label: t("QUESTIONNAIRE_TYPE_THERAPIST"),
    id: 4,
    Symbol: "QT",
    Name: t("QUESTIONNAIRE_TYPE_THERAPIST"),
  },
];
export const nextQuestionOptionsInitialState = [
  { value: "OptionId", label: "BY_OPTIONS" },
];
export const getNextQuestionOptionsInitialState = () => [
  { value: "OptionId", label: t("BY_OPTIONS") },
];
export const yesNoOptions: TLabeledItem[] = [
  { value: "0", label: "NO" },
  { value: "1", label: "YES" },
];
export const statusOptions: TLabeledItem[] = [
  { value: "1", label: "STATUS_ACTIVE"},
  { value: "0", label: "STATUS_INACTIVE"},
];
export const getStatusOptions = (): TLabeledItem[] => [
  { value: "1", label: t("STATUS_ACTIVE") },
  { value: "0", label: t("STATUS_INACTIVE") },
];
export const getNumberStatusOptions = (): INumberOption[] => [
  { value: 1, label: t("STATUS_ACTIVE") },
  { value: 0, label: t("STATUS_INACTIVE") },
];
export const questionnaireCategoryOptions: TLabeledItem[] = [
  { value: "רגיל", label: "רגיל" },
  { value: "סקר", label: "סקר" },
];
export const periodOptions: TLabeledItem[] = [
  { value: "monthly", label: "חודשי" },
  { value: "dayly", label: "יומי" },
  { value: "weekly", label: "שבועי" },
];
export const dayOptions: INumberOption[] = Array.from(
  { length: 31 },
  (_, index) => ({
    value: (index + 1),
    label: (index + 1).toString(),
  })
);
export const weekOptions: INumberOption[] = Array.from(
  { length: 5 },
  (_, index) => ({
    value: (index + 1),
    label: (index + 1).toString(),
  })
);
export const monthOptions: INumberOption[] = Array.from(
  { length: 12 },
  (_, index) => ({
    value: (index + 1),
    label: (index + 1).toString(),
  })
);
export const addOrEditCompanyInitialState: TCompany = {
  id: 0,
  name: "",
  nameEn: "",
  phone: "",
  payCallPhone: "",
  guid: "",
  parentCompanyId: null,
  statusId: 1,
  TrialDays: 0,
  isChargingCustomers: false,
  companyChargeTriggersId: null,
  therapistsCanSeePrices: false,
  audioRetentionDays: null,
  selectedPlanId: null,
};

export const addOrEditCompanyOnboardingInitialState: TCompanyOnboarding = {
  id: 0,
  name: "",
  nameEn: "",
  phone: "",
  guid: "",
  parentCompanyId: null,
  statusId: 1,
  isChargingCustomers: false,
  companyChargeTriggersId: null,
  // Additional fields for onboarding form
  email: "",
  contactFullName: "",
  positionTitle: "",
  companySizeId: "",
  sectorId: "",
  prefferedLanguageId: "",
  target_use_case: "",
  imageUrl: "",
  stampUrl: "",
  selectedPlanId: 0,
  selectedPlanPricesId: null,
  paymentsPeriodTypesId: 2,
  notes: "",
  languageId: undefined,
  // Step 7 settings fields
  emotionRecognition: undefined,
  highRiskAlerts: undefined,
  communicationChannels: [],
  therapistsCanSeePrices: false,
};

export const addOrEditQuestionnaireInitialState: Partial<IQuestionnaireData> = {
  id: 0,
  desc: "",
  symbol: "",
  statusId: 1,
  factorQuestionnaire: 1,
  category: "רגיל",
  chatGPTFeaturesId: null,
  aiQuestionsLimit: 0,
  AnalyzeText: false,
  GenerateClinicalSummary: false,
  AnalyzeAudioVideo: false,
  AnalyzeFiles: false,
  isFavorite: 0,
};
export const addNewFeatureInitialState: TAddFeatureRequest = {
  Name: "",
  Symbol: "",
  number: 0,
};
export const addNewExerciseInitialState: TExercise = {
  id: 0,
  title: "",
  about: "",
  companyId: 0,
  statusId: 1,
  exercisesCategoriesId: 0,
  generalRRMSEQ: 1,
};

export const editQuestionFormInitialState: Partial<IQuestion> = {
  desc: "",
  id: 0,
  nextQuestionId: null,
  questionnaireId: 0,
  dataTypesId: 1,
  seq: 1,
  statusId: 1,
  factorQuestion: 1,
  companyGroupsRRMHeadersId: 0,
  optionsCountMin: null,
  optionsCountMax: null,
  isSpecific: null,
  specificTypeId: "",
  userTableField: null,
  isSectionHeader: false,
};
export const questionOptionInitialState: TQuestionOption = {
  id: 0,
  desc: "",
  questionsId: 0,
  groupId: null,
  groups: null,
  nextQuestionId: 0,
  nextQuestions: null,
  seq: 0,
  factorAnswer: 1,
  statusId: 1,
  smsMessagesListId: null,
};
export const questionGroupInitialState: TGroup = {
  id: 0,
  name: "",
  questionsId: 0,
  seq: 0,
  factorGroup: 1,
  statusId: 1,
  optionsCountMin: 0,
  optionsCountMax: null,
};
export const addUserInitialState: TAddUserRequest = {
  guid: null,
  firstName: "",
  lastName: "",
  phone: "",
  email: "",
  birth: "",
  genderId: 3,
  passport: "",
  roleId: 1,
  fakeCompanyId: null,
  companyId: 0,
  statusId: 1,
  isConnection: null,
  cityId: null,
  address: ""
  
};
export const addStaffUserInitialState: TAddTherapistRequest = {
  ...addUserInitialState,
  specializationsId: null,
  vetek: null,
  migzarId: null,
};

export const RRMListDefault: TRRMListEntry[] = [
  {
    id: 1,
    title: "A",
    desc: null,
    color: "#5d3cc7",
    anliza: "",
    recommendations: "",
    highlights: "",
    conversation: "",
    companyId: 1,
    statusId: 1,
    rrmseq: 1,
    // Min: 0,
    // Max: 0,
  },
  {
    id: 2,
    title: "B",
    desc: null,
    color: "#4f0080",
    anliza: "",
    recommendations: "",
    highlights: "",
    conversation: "",
    companyId: 1,
    statusId: 1,
    rrmseq: 1,
    // Min: 0,
    // Max: 0,
  },
  {
    id: 3,
    title: "C",
    desc: null,
    color: "#fffe02",
    anliza: "",
    recommendations: "",
    highlights: "",
    conversation: "",
    companyId: 1,
    statusId: 1,
    rrmseq: 1,
    // Min: 0,
    // Max: 0,
  },
  {
    id: 4,
    title: "D",
    desc: null,
    color: "#ff7654",
    anliza: "",
    recommendations: "",
    highlights: "",
    conversation: "",
    companyId: 1,
    statusId: 1,
    rrmseq: 1,
    // Min: 0,
    // Max: 0,
  },
  {
    id: 5,
    title: "E",
    desc: null,
    color: "#ff7803",
    anliza: "",
    recommendations: "",
    highlights: "",
    conversation: "",
    companyId: 1,
    statusId: 1,
    rrmseq: 1,
    // Min: 0,
    // Max: 0,
  },
  {
    id: 6,
    title: "F",
    desc: null,
    color: "#cd2701",
    anliza: "",
    recommendations: "",
    highlights: "",
    conversation: "",
    companyId: 1,
    statusId: 1,
    rrmseq: 1,
    // Min: 0,
    // Max: 0,
  },
];

// Table IDs from database
export const TABLE_IDS = {
  NEW_INQUIRIES: 1,
  MY_INQUIRIES: 2,
  TREATMENT_PLANS: 3,
} as const;

export const PERMISSION_TYPES = {
  NO_PERMISSION: 1,
  READ_ONLY: 2,
  EDIT: 3,
} as const;

export const SCOPE_TYPES = {
  USER_SPECIFIC: 1,
  ALL_COMPANY: 2,
  ALL_ADMINS: 3,
  ALL_THERAPISTS: 4,
} as const;

export const noDataLabel = "NO_INFORMATION";

export const selectCustomStyles: StylesConfig<IOption, false> = {
  control: (provided) => ({
    ...provided,
    background: "#fff",
    borderColor: "#9e9e9e",
    minHeight: "24px",
    height: "24px",
  }),

  valueContainer: (provided) => ({
    ...provided,
    height: "24px",
    padding: "0 6px",
  }),

  input: (provided) => ({
    ...provided,
    margin: "0px",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "24px",
  }),
  singleValue: (provided) => ({
    ...provided,
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
  }),
};

export function calculateAge(birthDateString: string): number {
  const today = new Date();
  const birthDate = new Date(birthDateString);
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDifference = today.getMonth() - birthDate.getMonth();

  // Check if the birth month hasn't come yet this year, or if it's the same month but the day hasn't come yet
  if (
    monthDifference < 0 ||
    (monthDifference === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return age;
}

// export function findMinAndMax(items: TRRMListEntry[] | null): {
//   min: number;
//   max: number;
// } {
//   if (!items || items.length === 0) {
//     throw new Error("The array is empty");
//   }

//   let min = items[0].Min;
//   let max = items[0].Max;

//   for (const item of items) {
//     if (item.Min < min) {
//       min = item.Min;
//     }
//     if (item.Max > max) {
//       max = item.Max;
//     }
//   }

//   return { min, max };
// }

export function filterLastOfEachGroup(
  options: TLabeledQuestionOption[]
): TLabeledQuestionOption[] {
  if (!options.length || !options[0]?.GroupId) {
    return options;
  } else {
    const groupMap = options.reduce<Record<number, TLabeledQuestionOption>>(
      (acc, item) => {
        // @ts-ignore
        acc[item.GroupId] = item; // Overwrites previous entry with same GroupId with the current item
        return acc;
      },
      {}
    );

    return Object.values(groupMap);
  }
}
export const getSelectNote = (
  min: number | null,
  max: number | null,
  t: (key: string, opts?: any) => string
): string => {
  if (!min) return "";

  if (min === 1) {
    return max === 1
      ? t("SELECT_NOTE_ONE") 
      : t("SELECT_NOTE_ONE_MIN"); 
  }

  return t("SELECT_NOTE_AT_LEAST", { count: min }); 
};

export const isFormValid = (form: {
  [key: string]: {
    isValid: boolean;
  };
}): boolean => {
  return Object.keys(form).every((k) => form[k].isValid);
};

export type TLabeledQuestionOption = IOption & TReportQuestionOption;
export type TGrouppedQuestionsOptions = {
  label: string;
  options: TLabeledQuestionOption[];
};

export const transformServerOptions = (
  optionsArray: TReportQuestionOption[],
  count: number | null,
  min: null | number
): Array<TGrouppedQuestionsOptions | TLabeledQuestionOption> => {
  const groups: Record<string, TGrouppedQuestionsOptions> = {};
  const noGroup: TLabeledQuestionOption[] = [];

  optionsArray.forEach((option) => {
    if (option.GroupId) {
      const groupKey = `group-${option.GroupId}`;
      if (!groups[groupKey]) {
        groups[groupKey] = {
          label: option.Groups ? option.Groups.Name : "Default Group",
          options: [],
        };
      }
      groups[groupKey].options.push({
        ...option,
        count,
        min,
        value: option.Id.toString(),
        label: option.Desc,
      });
    } else {
      noGroup.push({
        ...option,
        count,
        min,
        value: option.Id.toString(),
        label: option.Desc,
      });
    }
  });
  for (const groupKey in groups) {
    if (groups[groupKey].options) {
      groups[groupKey].options.sort((a, b) => a.Seq - b.Seq);
    }
  }
  noGroup.sort((a, b) => a.Seq - b.Seq);
  return [...Object.values(groups), ...noGroup];
};

// Type guard function for TGrouppedQuestionsOptions
export function isTGrouppedQuestionsOptions(
  object: TGrouppedQuestionsOptions | TLabeledQuestionOption
): object is TGrouppedQuestionsOptions {
  return typeof object === "object" && object !== null && "options" in object;
}

export const initialQuestionState: Partial<IQuestion> = {
  id: 0,
  seq: 0,
  desc: "",
  statusId: 1,
  // isEnd: false,
  // descQuestionnaire: "",
  // typeQ: 0,
  // descDataType: "",
  // nextQuestionDesc: "",
};

export const ITEM_TYPE = {
  GROUP: "GROUP",
  OPTION: "OPTION",
  QUESTION: "QUESTION",
};

export const initialCompanyGroupsRRMHeaders: ICompanyGroupsRRMHeaders = {
  id: 0,
  companyId: 0,
  questionnaireId: 0,
  desc: "",
  isClini: false,
  isDefault: false,
  statusId: 1,
};

export const initialCompanyGeneralRRM: TGeneralRRM = {
  id: 0,
  companyId: 0,
  title: "",
  desc: "",
  color: "#ffffff",
  anliza: "",
  recommendations: "",
  highlights: "",
  conversation: "",
  statusId: 1,
  rrmseq: 1,
};
export const initialCompanyGroupsRRM: ICompanyGroupsRRM = {
  id: 0,
  companyId: 0,
  questionnaireId: null,
  companyGroupsRRMHeadersId: null,
  title: "",
  desc: "",
  color: "",
  anliza: "",
  recommendations: "",
  highlights: "",
  conversation: "",
  start: 0,
  end: 0,
  statusId: 1,
  seq: 0,
};
export const RRMHeadersTypesOptions: IBooleanOption[] = [
  { label: "CLINICAL", value: true },
  { label: "REGULAR", value: false },
];

export const treatmentPlanGeneralFilterOptions: TLabeledItem[] = [
  { value: "yearsOfExperience", label: "שנות ניסיון" },
  { value: "men", label: "גברים" },
  { value: "women", label: "נשים" },
];
export const treatmentPlanPsychologistFilterOptions: TLabeledItem[] = [
  ...treatmentPlanGeneralFilterOptions,
  { value: "clinical", label: t("CLINICAL") },
  { value: "rehabilitative", label: "שיקומי" },
  { value: "educational", label: "חינוכי" },
  { value: "developmental", label: "התפתחותי" },
  { value: "medical", label: "רפואי" },
];
export interface ITreatmentPlanFormField {
  id: string;
  label: string;
  placeholder: string;
  filterOptions?: TLabeledItem[];
}
export const addTreatmentPlanFormFields = [
  {
    id: "supporter",
    label: t("SUPPORT_ROLE"),
    placeholder: "אנא בחר ",
    filterOptions: treatmentPlanGeneralFilterOptions,
  },
  {
    id: "psychotherapist",
    label: "שיוך פסיכותרפיסט (MA)",
    placeholder: t("SELECT_PLACEHOLDER"),
    filterOptions: treatmentPlanPsychologistFilterOptions,
  },
  {
    id: "psychologist",
    label: "שיוך פסיכולוג",
    placeholder: "אנא בחר",
    filterOptions: treatmentPlanPsychologistFilterOptions,
  },
  {
    id: "psychiatrist",
    label: "שיוך פסיכיאטר",
    placeholder: "אנא בחר",
    filterOptions: treatmentPlanPsychologistFilterOptions,
  },
  { id: "protocol", label: "שיוך פרוטוקול", placeholder: "אנא בחר" },
];

// Category Type
export type TExercisesCategory = {
  id: number;
  companyId: number;
  name: string;
  statusId: number;
};

// Exercise Type
export type TExercise = {
  id: number;
  title: string;
  about: string;
  exercisesCategoriesId: number; // need to change to []
  companyId: number;
  generalRRMSEQ: number;
  link?: string;
  statusId: number;
  // audioLink?: string;
};

// Mock exercises data
//   {
//     link: "https://media.istockphoto.com/id/1413205857/video/group-of-young-multi-ethnic-gym-class-doing-practice-yoga-lesson-together-on-sunrise-morning.mp4?s=mp4-640x640-is&k=20&c=fSLBrMcv8WrQ9dGEX7tMjY5Fhok681tu66Xsx5JQZLc=",
//     title: "אתה עוצמתי",
//     about:
//       "זוהי מדיטציה מודרכת של 16 דקות מעצימה ומרפאה על להיות כוחני. זוהי תזכורת לכך שאתה יכול להיות בעל מוח מדיטטיבי עמוק. אתה אדם חזק ואתה חשוב! טיפול עצמי ואהבה עצמית הם כל כך חשובים כי אינך יכול להשפיע עמוקות ואוהבת על אנשים אחרים עד שאתה באמת אוהב ודואג לעצמך",
//   },
//   {
//     link: "https://media.istockphoto.com/id/1408178995/video/spa-still-life-stones-massage-and-water-relax-close-up-relaxing-view-of-burning-candles-water.mp4?s=mp4-640x640-is&k=20&c=Npc8krlrGkO29HLwGRKpyq8cGFtB8S95xyzHSbDI8zs=",
//     title: "מדיטציה ללב",
//     about:
//       "הקשיבו למדיטציה מודרכת זו של 20 דקות בכל יום וחקור את האהבה והחמלה שבתוך ליבנו כדי למצוא מצב של רגיעה ושלווה פנימית.",
//   },
//   {
//     link: "https://media.istockphoto.com/id/1295220207/video/serene-african-woman-relieving-stress-at-workplace-do-meditation-practice.mp4?s=mp4-640x640-is&k=20&c=Q4k98iuDSEz0qKFfZIukkbwwL0kfKTa9Dv_rfhaHOHk=",
//     title: "מדיטציה נגד חרדה",
//     about:
//       "נכתב וקריינות על ידי ג'ון דייוויסי. ג'ון הוא מאמן, מורה ודובר לחיים בתשומת לב.",
//   },
//   {
//     link: "https://media.istockphoto.com/id/1399551003/video/mindful-concentration-and-breathing.mp4?s=mp4-640x640-is&k=20&c=5vpaljndH1kbNSFXef66BVeMK3y_oTC8RhhFMb_9Szc=",
//     title: "מדיטציה לריפוי והשתחררות",
//     about:
//       "מדיטציה מודרכת של 10 דקות לריפוי, שחרור ושלווה פנימית. לרפא את הלב והפצעים הרגשיים שלך עם הדמיית אנרגיה חיובית, הקשה על צ'אקרת הלב לריפוי אנרגיה והצהרות חיוביות. מדיטציית ריפוי זו תעזור לך לטפח הכרת תודה, סליחה עצמית ופרספקטיבה למסע שלך. מעולה למתחילים",
//   },
// ];

// Initial state for QuestionnaireCompaniesHeaders
export const addOrEditQuestionnaireCompaniesHeadersInitialState: IQuestionnaireCompaniesHeaders =
  {
    id: 0,
    companyId: 0,
    desc: "",
    isDefault: false,
    statusId: 1,
    hasLinkedProtocols: false,
  };

// Initial state for QuestionnaireCompanies
export const addOrEditQuestionnaireCompaniesInitialState: IQuestionnaireCompanies =
  {
    id: 0,
    companyId: 0,
    questionnaireCompaniesHeadersId: 0,
    questionnaireCompaniesTypeId: 0,
    questionnaireCompaniesSpecificTypesId: null,
    userQuestionnaireId: 0,
    therapistQuestionnaireId: 0,
    dayly: undefined,
    weekly: undefined,
    monthly: undefined,
    statusId: 1,
  };

// Initial state for QuestionnaireCompaniesTypes
export const initialQuestionnaireCompaniesTypes: IQuestionnaireCompaniesTypes =
  {
    id: 0,
    name: "",
    nameEn: "",
    companyId: 0,
    statusId: 1,
    isEnum: false,
  };

export const initialAppointmentsProgram: IAppointmentsProgram = {
  id: 0,
  isApproved: true, //approved by default for admin
  companyId: 0,
  name: "",
  usersGuid: "0",
  roleId: 0,
  therapistsSpecializationsIds: null,
  countOfAppointments: 0,
  appointmentsDurationsId: 0,
  appointmentsDurationsOpenMinutes: null,
  mediasId: 0,
  appointmentsSequenceId: 0,
  appointmentsSequenceOpenCountInPeriod: null,
  createUsersId: 0,
  updateTherapistsUsersId: null,
  updateTherapistsDate: null,
  genderId: 0,
  migzarId: 0,
  fundingSourcesId: null,
  treatmentTypesId: null,
  comments: "",
  statusId: 1,
  dateToDelete: null, // NotMapped property
  deleteType: null, // NotMapped property
  updateUsersId: null,
  updateDate: null,
  available: 0,
  protocolId: null,
  treatmentRoomId: null,
  companyServicesId: null,
};

export function convertKeysToLowerCase(
  obj: Record<string, any>
): Record<string, any> {
  return Object.keys(obj).reduce((acc, key) => {
    const newKey = key.charAt(0).toLowerCase() + key.slice(1); // Convert the first letter to lowercase
    const value = obj[key];

    // Include only fields with a defined value (non-null, non-undefined, and not an empty string)
    if (value !== null && value !== undefined && value !== "") {
      acc[newKey] = value;
    }

    return acc;
  }, {} as Record<string, any>);
}

export const supportMessageInitialState: Partial<TSupportMessage> = {
  id: "0",
  companyId: 0,
  screenType: 3,
  subject: "",
  body: "",
  createdUsersId: "",
};

export const INACTIVITY_TIMEOUT = 18 * 60 * 1000; // 18 minutes until logout
export const WARNING_TIMEOUT = 15 * 60 * 1000; // 15 minutes until warning
// export const INACTIVITY_TIMEOUT = 4 * 60 * 1000; // for test
// export const WARNING_TIMEOUT = 1 * 60 * 1000; // for test

export const WARNING_DURATION = 3 * 60 * 1000;
export const formatCountdown = (seconds: number) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${String(minutes).padStart(2, "0")}:${String(
    remainingSeconds
  ).padStart(2, "0")}`;
};

export const getUsersStatusOptions = () => [
  { label: "ALL", value: -1 },
  { label: "STATUS_INACTIVE", value: 0 },
  { label: "STATUS_ACTIVE", value: 1 }
];

export const usersTreatmentProgramOptions = [
  {
    label: "ALL",
    value: -1,
  },
  {
    label: "WITHOUT_TREATMENT_PROGRAM",
    value: 0,
  },
  {
    label: "WITH_TREATMENT_PROGRAM",
    value: 1,
  },
];

export const week = [
  "יום א'",
  "יום ב'",
  "יום ג'",
  "יום ד'",
  "יום ה'",
  "יום ו'",
  "יום שבת'",
];

export const initialSmsMessage: TSmsMessage = {
  id: 0,
  companyId: 0,
  title: "",
  body: "",
  isSend: true,
  statusId: 1,
};

export const initialPlan: TPlan = {
  id: 0,
  name: "",
  companyId: 0,
  description: "",
  openFeaturesCount: 0,
  trialDays: 0,
  features: [],
  isDefault: false,
  statusId: 1,
  prices: [],  // Start with empty prices array
  plansPricesId: 0, // A plan being created has no price row yet
};

export const initialPlanPrice: TPlanPrice = {
  id: 0,
  plansId: 0,
  monthlyPrice: 0,
  monthlyPriceWithVat: 0,
  yearlyPrice: 0,
  yearlyPriceWithVat: 0,
  percentageDiscount: 0,
  currencyId: 1,
  languageId: 1,
  statusId: 1,
};

export const ColorPalette = [
  "rgba(9, 143, 239, 1)",
  "rgba(94, 67, 185, 1)",
  "rgba(218, 30, 40, 1)",
  "rgba(36, 161, 72, 1)",
  "rgb(76, 26, 117)",
  "rgba(240, 144, 53, 1)",
  "rgba(255, 193, 7, 1)",
];

export const BottomColorPalette = [
  "rgba(94, 67, 185, 1)",
  "rgba(9, 143, 239, 1)",
  "rgba(218, 30, 40, 1)",
  "rgba(240, 144, 53, 1)",
];

export const filterOptionsTreatmentPlan = [
  { value: "today", label: "היום" },
  { value: "week", label: "השבוע" },
  { value: "month", label: "החודש" },
];

// Wait time mock data (flat, server-style)
export const mockWaitTimeData = [
  { graphName: t("PHONE"), category: "2025-06-01", value: 120 },
  { graphName: t("PHONE"), category: "2025-06-02", value: 80 },
  { graphName: t("PHONE"), category: "2025-06-03", value: 200 },
  { graphName: t("PHONE"), category: "2025-06-04", value: 60 },
  { graphName: t("PHONE"), category: "2025-06-05", value: 170 },
  { graphName: "קליניקה", category: "2025-06-01", value: 90 },
  { graphName: "קליניקה", category: "2025-06-02", value: 140 },
  { graphName: "קליניקה", category: "2025-06-03", value: 70 },
  { graphName: "קליניקה", category: "2025-06-04", value: 180 },
  { graphName: "קליניקה", category: "2025-06-05", value: 100 },
  { graphName: "צ'אט", category: "2025-06-01", value: 60 },
  { graphName: "צ'אט", category: "2025-06-02", value: 120 },
  { graphName: "צ'אט", category: "2025-06-03", value: 30 },
  { graphName: "צ'אט", category: "2025-06-04", value: 90 },
  { graphName: "צ'אט", category: "2025-06-05", value: 150 },
  { graphName: "וידאו", category: "2025-06-01", value: 180 },
  { graphName: "וידאו", category: "2025-06-02", value: 60 },
  { graphName: "וידאו", category: "2025-06-03", value: 220 },
  { graphName: "וידאו", category: "2025-06-04", value: 100 },
  { graphName: "וידאו", category: "2025-06-05", value: 140 },
];

// RRM level mock data (flat, server-style)
export const mockRRMLevelData = [
  { graphName: "דירוג 1", category: "2025-06-01", value: 2 },
  { graphName: "דירוג 1", category: "2025-06-02", value: 5 },
  { graphName: "דירוג 1", category: "2025-06-03", value: 1 },
  { graphName: "דירוג 1", category: "2025-06-04", value: 4 },
  { graphName: "דירוג 1", category: "2025-06-05", value: 3 },
  { graphName: "דירוג 2", category: "2025-06-01", value: 6 },
  { graphName: "דירוג 2", category: "2025-06-02", value: 2 },
  { graphName: "דירוג 2", category: "2025-06-03", value: 7 },
  { graphName: "דירוג 2", category: "2025-06-04", value: 3 },
  { graphName: "דירוג 2", category: "2025-06-05", value: 5 },
  { graphName: "דירוג 3", category: "2025-06-01", value: 3 },
  { graphName: "דירוג 3", category: "2025-06-02", value: 1 },
  { graphName: "דירוג 3", category: "2025-06-03", value: 5 },
  { graphName: "דירוג 3", category: "2025-06-04", value: 2 },
  { graphName: "דירוג 3", category: "2025-06-05", value: 4 },
  { graphName: "דירוג 4", category: "2025-06-01", value: 1 },
  { graphName: "דירוג 4", category: "2025-06-02", value: 4 },
  { graphName: "דירוג 4", category: "2025-06-03", value: 0 },
  { graphName: "דירוג 4", category: "2025-06-04", value: 6 },
  { graphName: "דירוג 4", category: "2025-06-05", value: 2 },
];

export const initialSpecializationForm: TSpecialization = {
  id: 0,
  name: "",
  statusId: 1,
  therapistsSpecializationsTypesId: 1,
};
export const specializationAreas: ISpecializationArea[] = [
  { id: 1, value: 1, labelKey: "SPECIALIZATION_AREA_GENERAL" },
  { id: 2, value: 2, labelKey: "SPECIALIZATION_AREA_AUDIENCE" },
  { id: 3, value: 3, labelKey: "SPECIALIZATION_AREA_APPROACH" },
];
export const welcomeMessages = [
  "ברוכים הבאים לצוות המטפלים של “דעת לנפש”!",
  "אנחנו שמחים ונרגשים על הצטרפותכם לפרויקט החשוב של סיוע לילדי משפחות המילואים במסגרת “מקשיבים”.",
  "הנוכחות המקצועית והלב הרחב שאתם מביאים אתכם מהווים חיזוק משמעותי לתוכנית, במיוחד בתקופה כה רגישה עבור הילדים והמשפחות.",
  "אנחנו בטוחים שהמומחיות, הרגישות והניסיון שלכם יסייעו לנו להעניק מענה רגשי עמוק, איכותי ומחבק – כזה שיכול באמת לשנות חיים.",
  "תודה שאתם כאן איתנו.",
  "בשם כל הילדים וההורים שיזכו לפגוש אתכם – תודה!",
];

export interface ICategory {
  value: string;
  title: string;
  img: string;
}

export const adminLinks: ICategory[] = [
  {
    value: "#updates",
    img: messagesIcon,
    title: "UPDATES_2",
  },
  {
    value: "#notifications",
    img: calendarIcon,
    title: "RISK_ALERTS",
  },
  {
    value: "#pendingTreatmentPlans",
    img: treatmentPlanIcon,
    title: "PENDING_TREATMENT_PLANS",
  },
  {
    value: "reports",
    img: reportsIcon,
    title: "REPORTS",
  },
];

export const testUserEmail = "-";

export const initialTreatmentRoom = {
  id: 0,
  name: "",
  capacity: 1,
  location: "",
  features: [] as number[],
  treatmentTypeId: 1,
  therapyTypeId: 1,
  statusId: 1,
};

export const initialTreatmentGroup = {
  id: 0,
  groupName: "",
  maxParticipants: undefined,
  therapyTypeId: undefined,
  therapistId: undefined,
  statusId: 1,
};

export const sanitizeUrlString = (value: string): string => {
  return value
    .replace(/\s+/g, '_')           // spaces → underscores
    .replace(/[^a-zA-Z0-9_-]/g, '') // remove invalid chars
};

export const roundPrice = (value: number): number => {
  return Math.round(value * 100) / 100;
};

export const filterSelectStyles = {
  menu: (base: object) => ({ ...base, fontSize: "0.875rem" }),
  option: (base: object) => ({
    ...base,
    fontSize: "0.875rem",
    padding: "0.4rem 0.75rem",
  }),
  singleValue: (base: object) => ({ ...base, fontSize: "0.875rem" }),
  multiValue: (base: object) => ({ ...base, fontSize: "0.875rem" }),
};

export const getCurrentMonthYear = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
};

export const formatCurrency = (amount: number): string => {
  return `₪${roundPrice(amount).toLocaleString("he-IL")}`;
};

export const formatPercent = (pct: number): string => {
  return `${roundPrice(pct)}%`;
};

export type TSortOption = { value: string; label: string };
export const SORT_OPTIONS: TSortOption[] = [
  { value: "reportDate",    label: "REPORT_SORT_SESSIONS" },
  { value: "appointmentDate",    label: "REPORT_SORT_APPOINTMENTS" },
  { value: "income",        label: "REPORT_SORT_REVENUE" },
  { value: "amountPaid",    label: "REPORT_SORT_AMOUNT_PAID" },
  { value: "amountDue",     label: "REPORT_SORT_AMOUNT_DUE" },
  { value: "therapistRate", label: "REPORT_SORT_THERAPIST_RATE" },
  { value: "profitability", label: "REPORT_SORT_PROFITABILITY" },
  { value: "therapist",     label: "REPORT_SORT_THERAPIST" },
  { value: "usersName",     label: "REPORT_SORT_USERSNAME" },
  { value: "serviceType",   label: "REPORT_SORT_SERVICE_TYPE" },
  { value: "status",        label: "REPORT_SORT_STATUS" },
];

export const USER_SORT_OPTIONS: TSortOption[] = [
  { value: "balance",      label: "USER_SORT_BALANCE" },
  { value: "oldestDebt",   label: "USER_SORT_OLDEST_DEBT" },
  { value: "dateRegister", label: "USER_SORT_DATE_REGISTER" },
  { value: "fullName",     label: "USER_SORT_FULL_NAME" },
];

export const USER_STAFF_SORT_OPTIONS: TSortOption[] = [
  { value: "availabilityHours", label: "USER_SORT_AVAILABILITY_HOURS" },
  { value: "totalReports",      label: "USER_SORT_TOTAL_REPORTS" },
  { value: "sessionCost",       label: "USER_SORT_SESSION_COST" },
  { value: "roleId",            label: "USER_SORT_ROLE" },
  { value: "dateRegister",      label: "USER_SORT_DATE_REGISTER" },
  { value: "fullName",          label: "USER_SORT_FULL_NAME" },
];

export const CATEGORY_OPTIONS = [
  { value: "" as const,           label: "ALL" },
  { value: "THERAPIST" as const,  label: "THERAPIST" },
  { value: "CLIENT" as const,     label: "SCREEN_NAME_CLIENT" },
] satisfies { value: "" | "THERAPIST" | "CLIENT"; label: string }[];